// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1243":"476a17a8","1356":"01ef29f3","2514":"0c6b18e8"}[chunkId] + ".chunk.css";
};